import React, { useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { Button, Input } from '../../components';
import SEO from '../../components/common/SEO';
import { submitNewPassword } from './AuthRecovery.helper';

const ResetPassword = () => {
  const [searchParams] = useSearchParams();
  const [form, setForm] = useState({ password: '', confirmPassword: '' });
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = async (event) => {
    event.preventDefault();
    setLoading(true);
    setError('');
    try {
      const result = await submitNewPassword({ token: searchParams.get('token'), ...form });
      setMessage(result.message);
    } catch (err) {
      setError(err.message || 'Unable to reset your password.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <main className="lh-reset-password min-h-screen bg-gradient-to-br from-dark-50 via-white to-primary-50 flex items-center justify-center p-4">
      <SEO title="Choose New Password" canonicalPath="/reset-password" noIndex />
      <section className="w-full max-w-md">
        <Link to="/" className="flex items-center justify-center gap-2 mb-8">
          <img src="/lat-icon.png" alt="Lotus Arc Technologies" className="h-14 w-auto" />
          <span className="text-2xl font-bold text-dark-900">LAT</span>
        </Link>
        <div className="bg-white rounded-2xl shadow-xl p-8">
          <h1 className="text-2xl font-bold text-dark-900 text-center mb-2">Choose a new password</h1>
          <p className="text-dark-500 text-center mb-7">Use at least eight characters for your new password.</p>
          {message ? (
            <div>
              <div className="bg-green-50 border border-green-200 text-green-700 px-4 py-3 rounded-lg text-sm">{message}</div>
              <Link to="/login" className="block text-center mt-6 text-primary-500 font-medium">Continue to sign in</Link>
            </div>
          ) : (
            <form onSubmit={handleSubmit} className="space-y-5">
              {error && <div className="bg-red-50 border border-red-200 text-red-600 px-4 py-3 rounded-lg text-sm">{error}</div>}
              <Input
                label="New Password"
                type="password"
                name="password"
                value={form.password}
                onChange={(event) => setForm((current) => ({ ...current, password: event.target.value }))}
                required
              />
              <Input
                label="Confirm Password"
                type="password"
                name="confirmPassword"
                value={form.confirmPassword}
                onChange={(event) => setForm((current) => ({ ...current, confirmPassword: event.target.value }))}
                required
              />
              <Button type="submit" variant="primary" fullWidth loading={loading}>Update password</Button>
            </form>
          )}
        </div>
      </section>
    </main>
  );
};

export default ResetPassword;
